export default __webpack_public_path__ + "static/media/apps.70657d32.svg";